import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Trans, useTranslation } from 'next-i18next';
import { BarChart } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/BarChart/index.js';
import { Category } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/index.js';
import { CategoryBadge } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/CategoryBadge/index.js';
import { CategoryItem } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/CategoryItem.js';
import { ReviewChart } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/ReviewChart.js';
import { SummaryBadge } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/SummaryBadge.js';
import { TrendNegativeIcon } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/TrendNegativeIcon.js';
import { TrendNeutralIcon } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/TrendNeutralIcon.js';
import { TrendPositiveIcon } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/TrendPositiveIcon.js';
import { useRating } from '../../../../../../components/HotelDetailsOverlay/hooks/useRating.js';
import { REVIEW_TREND_NEGATIVE, REVIEW_TREND_NEUTRAL, REVIEW_TREND_POSITIVE } from '../../../../../../components/HotelDetailsOverlay/models.js';
import { HeadlineMedium, LabelMediumBold, LabelSmall, RatingBadge, RatingSnippet, Stack } from '../../../../../../primitives/index.js';
const iconsByTrend = {
  [REVIEW_TREND_POSITIVE]: _jsx(TrendPositiveIcon, {}),
  [REVIEW_TREND_NEUTRAL]: _jsx(TrendNeutralIcon, {}),
  [REVIEW_TREND_NEGATIVE]: _jsx(TrendNegativeIcon, {})
};
export const RelevantNow = ({
  data
}) => {
  const {
    t
  } = useTranslation();
  const formatScore = useRating();
  if (!data) {
    return null;
  }
  const summaryScore = formatScore(data.summary.score);
  return _jsxs(Stack, {
    children: [_jsxs(Stack, {
      spacing: "xSmall",
      children: [_jsx(HeadlineMedium, {
        children: t('hotelDetailsOverlay:ratingSection.relevantNow.title')
      }), _jsx(LabelSmall, {
        color: "contentSecondary",
        children: t('hotelDetailsOverlay:ratingSection.relevantNow.titleDescription')
      })]
    }), _jsxs(Stack, {
      children: [_jsx(HeadlineMedium, {
        children: t('hotelDetailsOverlay:ratingSection.relevantNow.summaryTitle')
      }), _jsxs(SummaryBadge, {
        children: [_jsx(RatingSnippet, {
          badge: _jsx(RatingBadge, {
            variant: "horizontal",
            category: "neutral",
            sentiment: summaryScore.sentiment,
            children: `${summaryScore.scoreFormatted} / ${summaryScore.scoreMax}`
          }),
          label: t('hotelDetailsOverlay:ratingSection.relevantNow.summaryLabel', {
            scoreDescription: data.summary.scoreDescription
          }),
          description: t('hotelDetailsOverlay:ratingSection.xReviews', {
            count: data.summary.reviewCount
          })
        }), iconsByTrend[data.summary.trend]]
      }), _jsxs(ReviewChart, {
        children: [_jsx(LabelSmall, {
          color: "contentSecondary",
          children: _jsx(Trans, {
            i18nKey: "hotelDetailsOverlay:ratingSection.relevantNow.reviewChartLabel",
            components: {
              bold: _jsx(LabelMediumBold, {})
            }
          })
        }), _jsx(BarChart, {
          values: data.reviewsLastMonths
        })]
      })]
    }), data.categories?.map(({
      subCategories,
      ...category
    }) => {
      const categoryScore = formatScore(category.score);
      return _jsx(Category, {
        title: category.caption,
        badge: _jsx(CategoryBadge, {
          label: `${categoryScore.scoreFormatted} / ${categoryScore.scoreMax}`,
          description: t('hotelDetailsOverlay:ratingSection.xReviews', {
            count: category.reviewCount
          }),
          large: true
        }),
        children: subCategories?.map(subCategory => {
          const subCategoryScore = formatScore(category.score);
          return _jsx(CategoryItem, {
            title: subCategory.caption,
            description: subCategory.text,
            badge: _jsx(CategoryBadge, {
              label: `${subCategoryScore.scoreFormatted} / ${subCategoryScore.scoreMax}`,
              description: t('hotelDetailsOverlay:ratingSection.xReviews', {
                count: subCategory.reviewCount
              })
            })
          }, subCategory.id);
        })
      }, category.id);
    })]
  });
};